export default state => state.category.details || {};
